/* eslint-disable react/react-in-jsx-scope */
import React, { useState } from 'react';
import {
  Container,
  Stack,
  Typography,
  Button,
  Box,
  SvgIcon
} from '@mui/material';
import PlusIcon from '@heroicons/react/24/solid/PlusIcon';
import { TeachersList } from './TeacherList';
import AddTeacher from './AddTeacher';

function Teachers() {
  const [open, setOpen] = useState(false);
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8
      }}
    >
      <Container maxWidth="xl">
        <Stack spacing={3}>
          <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Stack spacing={1}>
              <Typography variant="h4">Teachers</Typography>
            </Stack>
            <div>
              <Button
                onClick={() => setOpen((state) => !state)}
                startIcon={
                  <SvgIcon fontSize="small">
                    <PlusIcon />
                  </SvgIcon>
                }
                variant="contained"
              >
                Add Teacher
              </Button>
            </div>
          </Stack>
          <TeachersList />
          <AddTeacher open={open} handleClickOpen={setOpen} />
        </Stack>
      </Container>
    </Box>
  );
}

export default Teachers;
